import { EvtHeader } from "components/header";
import React from "react";
import JobTitleForm from "../form";

const CreateJobTitle = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Job Title" />
      <div className="p-6 max-w-2xl">
        <JobTitleForm />
      </div>
    </div>
  );
};

export default CreateJobTitle;
